import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { flatten } from 'flat';

@Injectable({
  providedIn: 'root'
})
export class HttpParamsHelpersService {
  public objectToHttpParams(params: Record<string, any>): HttpParams {
    // Grab all query parameters into dictionary and then flatten it
    const dict: Record<string, any> = flatten(params || {});

    // Omit all `null` and `undefined` values, all empty objects and arrays from query parameters
    Object.keys(dict).forEach((key) => {
      if (
        dict[key] === null ||
        dict[key] === undefined ||
        (Array.isArray(dict[key]) && dict[key].length < 1) ||
        (typeof dict[key] === 'object' && !Object.keys(dict[key])?.length)
      ) {
        delete dict[key];
      }
    });

    // Make new Angular query parameters and fill them with flattened dictionary data
    let httpParams = new HttpParams();
    Object.keys(dict).forEach((key) => {
      const value = dict[key];
      if (Array.isArray(value)) {
        value.forEach((item) => {
          httpParams = httpParams.append(key, item);
        });
      } else {
        httpParams = httpParams.set(key, value);
      }
    });

    return httpParams;
  }
}
